import { render, staticRenderFns } from "./NuevoContacto.vue?vue&type=template&id=b90aa860"
import script from "./NuevoContacto.vue?vue&type=script&lang=js"
export * from "./NuevoContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports